import { Badge } from "@mzc-pdc/ui";
import theme from "@styles/theme";

const BadgeCollection = ({ totalCount }) => {
    return (
        <Badge
            sx={{
                ".MuiBadge-badge": {
                    position: `static`,
                    minWidth: theme.spacing(2.75),
                    height: 18,
                    px: 0.5,
                    transform: `none`,
                    backgroundColor: totalCount ? theme.palette.success[50] : theme.palette.greySecondary[100],
                    color: totalCount ? theme.palette.success.main : theme.palette.greySecondary[600],
                    fontSize: theme.typography.body3_700,
                },
            }}
            badgeContent={totalCount > 99 ? "99+" : totalCount?.toString() ?? "0"}
        />
    );
};

export default BadgeCollection;
